import React, { useState } from 'react';
import {
    Route as ReactRouterRoute,
    Routes as ReactRouterRoutes,
} from 'react-router-dom';
import { Route } from '../../../../types';
import { DPage } from '../../../dum';
import { SUpsertEmployeeDialog } from '../../../smart';
import { EmployeePage } from './employee/employee-page';
import { EmployeesPage } from './employees/employees-page';
import { DFab } from '../../../dum/simple/button/d-fab';

const productsPages: Route[] = [
    {
        name: 'EmployeesListPage',
        path: '/',
        component: <EmployeesPage />,
        title: 'Empleados',
        navbar: false,
    },
    {
        name: 'EmployeePage',
        path: '/:employeeId',
        component: <EmployeePage />,
        title: 'Empleados',
        navbar: false,
    },
];

export function EmployeesHomePage() {
    const [employeeDialog, setEmployeeDialog] = useState(false);

    return (
        <DPage>
            <DFab
                onClick={() => {
                    setEmployeeDialog(true);
                }}
            />
            <ReactRouterRoutes>
                {productsPages.map((page, index) => {
                    return (
                        <ReactRouterRoute
                            path={page.path}
                            element={page.component}
                            key={index}
                        />
                    );
                })}
            </ReactRouterRoutes>
            <SUpsertEmployeeDialog
                open={employeeDialog}
                setOpen={setEmployeeDialog}
            />
        </DPage>
    );
}
